import Avatar from "./avatar";
import classes from "../classes";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import expandable from "./higher-order/expandable";
import findBet from "../find-bet";
import findCurrentRaceIndex from "../find-current-race-index";
import { FormattedPayout } from "./formatted-currency";
import { hasPayout } from "../payouts";
import LeaderboardMeta from "./leaderboard-meta";
import LeaderboardMovement from "./leaderboard-movement";
import LeaderboardPicks from "./leaderboard-picks";
import React from "react";
import { TooltipBlock } from "./tooltip";
import TowelIcon from "./towel-icon";
import { trackEvent } from "../analytics";

export default expandable(class LeaderboardItem extends React.PureComponent {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    var { bets, expanded, races, ticket, toggle } = this.props;

    if (hasPicks(races, bets, ticket.get("id"))) {
      toggle();
    }
    if (!expanded) {
      var rank = ticket.get("rank") || 0;
      trackEvent("Leaderboard", "expand_player", "Rank " + rank, rank);
    }
  }

  render() {
    var { bets, currentUserId, expanded, expandedRace, isLast, payouts, raceEntrants, races, ticket, ticketScores, tokenTypes, tournament, users } = this.props;

    var user = users.get(ticket.get("user_id"));
    var username = "---";
    var userTooltip;
    if (user !== undefined) {
      username = user.get("username");
      var first = user.get("first_name") || "";
      var last = user.get("last_name") || "";
      userTooltip = first + " " + last + " @" + username;
    }

    var picks = null;
    if (expanded) {
      picks = (
        <CSSTransition
          classNames="leaderboard_link"
          timeout={{ enter: 250, exit: 250 }}>
          <LeaderboardPicks bets={bets} key="leaderboard-picks" raceEntrants={raceEntrants} races={races} ticket={ticket} ticketScores={ticketScores} tournament={tournament} />
        </CSSTransition>
      );
    }

    var score = ticket.get("score");
    if (tournament.get("tournament_type") === "Survivor") {
      score = Math.floor(score);
      if (score === 1) {
        score += " Win";
      } else {
        score += " Wins";
      }
    }

    var movement;
    var raceStatuses = races.map((race) => race.get("status")).toJS();
    var hasOneFinalizedRace = false;
    for (var i = raceStatuses.length - 1; i >= 0; i--) {
      if (raceStatuses[i] === "final") {
        hasOneFinalizedRace = true;
        var raceId = races.getIn([i, "id"]);
        var ticketScore = findBet(ticketScores, raceId, ticket.get("id"));
        if (ticketScore) {
          movement = <LeaderboardMovement movement={ticketScore.get("rank_change")} />;
        }
        break;
      }
    }

    var inTheMoneyPlace = Object.keys(payouts).map(place => parseInt(place)).reduce((a, b) => Math.max(a, b));
    var inTheMoney = hasPayout(ticket) || (
      tournament.get("status") !== "final" &&
      tournament.get("tournament_type") !== "Survivor" &&
      hasOneFinalizedRace &&
      ticket.get("rank") <= inTheMoneyPlace);

    return (
      <li className="leaderboard_item">
        <div
          className={classes({
            "leaderboard_link": true,
            "leaderboard_link--is-disabled": !hasPicks(races, bets, ticket.get("id")),
            "leaderboard_link--current-user": currentUserId === ticket.get("user_id"),
            "leaderboard_link--is-eliminated": ticket.get("eliminated_by_race_id") && tournament.get("status") !== "final",
            "leaderboard_link--is-open": expanded,
            "leaderboard_link--is-winner": inTheMoney
          })}
          onClick={this.toggle}>
          <ul className="leaderboard_player">
            <li className="leaderboard_player_cell leaderboard_player_cell--rank">
              <span className="leaderboard_rank">
                {ticket.get("rank")}
              </span>
            </li>

            <li className="leaderboard_player_cell leaderboard_player_cell--movement">
              {movement}
            </li>

            <li className="leaderboard_player_cell leaderboard_player_cell--name">
              <TooltipBlock onDark speed="fast" text={userTooltip} type={isLast ? "last" : "right"}>
                <div className="leaderboard_username">
                  <div className="leaderboard_username_cell">
                    <Avatar tiny user={user} />
                  </div>

                  <div className="leaderboard_username_cell">
                    <span className="leaderboard_name">
                      <span>
                        {username}
                      </span>

                      <span>
                        (
                        {ticket.get("ticket_number")}
                        )
                      </span>
                    </span>

                    <LeaderboardMeta currentUserId={currentUserId} ticket={ticket} user={user} />
                  </div>
                </div>
              </TooltipBlock>
            </li>

            <ThirdColumn
              bets={bets}
              expandedRace={expandedRace}
              raceEntrants={raceEntrants}
              races={races}
              ticket={ticket}
              tokenTypes={tokenTypes}
              tournament={tournament} />

            <li className="leaderboard_player_cell leaderboard_player_cell--score">
              {score}
            </li>
          </ul>

          <TransitionGroup>
            {picks}
          </TransitionGroup>
        </div>
      </li>
    );
  }
});

function hasPicks(races, bets, ticketId) {
  var r = races.find((race) => {
    var bet = findBet(bets, race.get("id"), ticketId);
    return bet !== undefined;
  });
  return r !== undefined;
}

function ThirdColumn({ bets, expandedRace, raceEntrants, races, ticket, tokenTypes, tournament }) {
  if (tournament.get("status") === "final" && expandedRace === undefined) {
    if (hasPayout(ticket)) {
      return (
        <li className="leaderboard_player_cell leaderboard_player_cell--winnings">
          <FormattedPayout
            ticket={ticket}
            tokenTypes={tokenTypes} />
        </li>
      );
    }
  } else if (expandedRace !== undefined) {
    var expandedRaceIndex = races.findIndex(race => race.get("id") === expandedRace);
    var currentRace;
    if (expandedRaceIndex !== -1) {
      currentRace = races.get(expandedRaceIndex);
    }
    if (isSurvivorUntilRaceIndex(expandedRaceIndex, ticket) && currentRace && currentRace.get("status") !== "open") {
      return (
        <LeaderboardPickForTicket
          bets={bets}
          raceEntrants={raceEntrants}
          raceId={expandedRace}
          ticketId={ticket.get("id")} />
      );
    }
  }
  var currentRaceIndex = findCurrentRaceIndex(races);
  if (currentRaceIndex !== undefined && isSurvivorUntilRaceIndex(currentRaceIndex, ticket)) {
    var raceId = races.getIn([currentRaceIndex, "id"]);
    return (
      <LeaderboardPickForTicket
        bets={bets}
        raceEntrants={raceEntrants}
        raceId={raceId}
        ticketId={ticket.get("id")} />
    );
  }
  return <li className="leaderboard_player_cell leaderboard_player_cell--pick" />;
}

function isSurvivorUntilRaceIndex(raceIndex, ticket) {
  return ticket.get("eliminated_by_race_number") === null ||
    raceIndex + 1 <= ticket.get("eliminated_by_race_number");
}

function LeaderboardPickForTicket({ bets, raceEntrants, raceId, ticketId }) {
  var bet = findBet(bets, raceId, ticketId);
  if (bet === undefined) {
    return (
      <li className="leaderboard_player_cell leaderboard_player_cell--pick">
        <i className="dw-warning5 dw--1-5x" />

        <div>
          No Pick
        </div>
      </li>
    );
  } else if (bet.get("race_entrant_id") === null) {
    return (
      <li className="leaderboard_player_cell leaderboard_player_cell--pick">
        <i className="dw-star_outline dw--2x" />

        <div>
          PTF
        </div>
      </li>
    );
  } else {
    var entrant = raceEntrants.get(bet.get("race_entrant_id"));
    if (!entrant) {
      return null;
    }
    return (
      <li className="leaderboard_player_cell leaderboard_player_cell--pick">
        <TowelIcon lane={entrant.get("lane_number")} small />

        <div>
          {entrant.get("morning_line")}
        </div>
      </li>
    );
  }
}
